import type { Currency } from '@navio/nsdk';

const DISCOUNT_AMOUNT_MIN = 0;
export const DISCOUNT_PERCENTAGE_MIN = 0;
export const DISCOUNT_PERCENTAGE_MAX = 100;

export const discountPercentageInputProps = () => ({
  label: 'Discount percentage',
  tooltip: 'How much percent is taken off the price (0-100).',
  type: 'number' as const,
  min: DISCOUNT_PERCENTAGE_MIN,
  max: DISCOUNT_PERCENTAGE_MAX,
  endAdornment: <p className='text-sm text-muted-foreground'>%</p>
});

export const discountAmountInputProps = ({ currency }: { currency: Currency }) => ({
  label: 'Discount amount',
  tooltip: 'How much money is taken off the price.',
  type: 'number' as const,
  min: DISCOUNT_AMOUNT_MIN,
  endAdornment: <p className='text-sm text-muted-foreground'>{currency}</p>
});

export const isValidDiscountAmount = (amount: number | null): boolean =>
  amount !== null && Number.isFinite(amount) && amount >= DISCOUNT_AMOUNT_MIN;

export const isValidDiscountPercentage = (percentage: number | null): boolean =>
  percentage !== null &&
  Number.isFinite(percentage) &&
  percentage >= DISCOUNT_PERCENTAGE_MIN &&
  percentage <= DISCOUNT_PERCENTAGE_MAX;
